import React, { useState, useContext, useEffect } from 'react';
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { useSelector } from "react-redux";
import { ucfirst } from "../../../../Helpers/StringHelper";
import { BookingFormContext } from "../BookingFormProvider";
import { BOOKINGS_API_URL } from "../../Bookings";

const BookingFormUserSectionDisabled = () => {
    const {
        booking,
    } = useContext(BookingFormContext);

    const siteTypeLabel = useSelector(state => state.global.siteTypeLabel);

    const [userName, setUserName] = useState('');
    const [unitName, setUnitName] = useState('');

    /**
     * Retrieve & populate with user email & telephone when user is selected
     */
    useEffect(() => {
        if (!booking.user_id) {
            return;
        }

        axios.get(`${BOOKINGS_API_URL}universal/users/${booking.user_id}`)
            .then(response => {
                const userData = response.data.data;
                const foundUnit = userData.units.find(unit => unit.id === booking?.unit_id);
                setUserName(userData.fullname);
                setUnitName(foundUnit.name);
            });

    }, [booking?.user_id, booking?.unit_id])

    return (
        <section className="section form-container full margin-bottom-0">
            <FormRow
                label="Full Name"
            >
                <input
                    type="text"
                    name="user_name"
                    value={userName}
                    disabled
                />
            </FormRow>

            <FormRow
                label={ucfirst(siteTypeLabel)}
            >
                <input
                    type="text"
                    name="unit_name"
                    value={unitName}
                    disabled
                />
            </FormRow>
        </section>
    )
}

export default BookingFormUserSectionDisabled
